import React, { useEffect } from 'react';

import SelectCategory from './SelectCategory';
import TopicTag from './TopicTag';
import { concat } from 'lodash';

import './Categorization.scss';
import { Selected } from './TopicTag/Selected/Selected';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export type ComponentProps = {
	tags: { tagIds: string[], newTagNames: string[] };
	hideOldCategories?: boolean
	hideNewCategories?: boolean
	onAddTags(tagIds: string[], newTagNames: string[]): void;
	onRemoveTag(tag: string): void;
	onSetCategory(category: string): void;
};

const MAX_TAGS = 10;

export const Categorization: React.FC<ComponentProps> = props => {
	const { t } = useTranslation();
	const suggestedTags = useSelector((state: RootState) => state.ui.urlQuery.suggested_tags);

	const { tags, hideOldCategories = false, hideNewCategories = false } = props;
	const { onAddTags, onRemoveTag, onSetCategory } = props;

	const [suggestedLoaded, setSuggestedLoaded] = React.useState<boolean>(false);

	if (suggestedTags && !suggestedLoaded) {
		tags.tagIds = Array.from(new Set(concat(tags.tagIds, suggestedTags)));
		setSuggestedLoaded(true);
	}

	const [categories, setCategories] = React.useState<string[]>([]);
	const [maxCategoryWarning, setMaxCategoryWarning] = React.useState<boolean>(false);

	useEffect(() => {
		setMaxCategoryWarning(tags.tagIds.length + tags.newTagNames.length >= MAX_TAGS);
	}, [tags]);

	const renderCategorySelect = (showNewLabel = false) => (
		<SelectCategory
			categories={categories}
			showNewlabel={showNewLabel}
			onAddCategory={category => {
				setCategories([category]);
				onSetCategory(category);
			}}
		/>
	);

	return (
		<div className="categorization">
			{!hideOldCategories && !hideNewCategories && (
				<div className="confirm-info categorization-category-label">
					{t('results.bulk_action.categorize')}
				</div>
			)}

			{!hideOldCategories && renderCategorySelect(false)}
			{!hideNewCategories && renderCategorySelect(true)}

			<TopicTag selectedTags={tags} onAddTags={(tagsId, newTagNames) => {
				if (tags.tagIds.length + tags.newTagNames.length >= MAX_TAGS) return;
				onAddTags(tagsId, newTagNames);
			}} />
			{
				maxCategoryWarning &&
				<div className='max-tag-warning'>
					<p>{t('results.categorize.tags.maxTagWarningIntro')}: {MAX_TAGS}</p>
					<p>{t('results.categorize.tags.maxTagWarningAdvice')}</p>
				</div >
			}
			<Selected selectedTags={tags} onRemoveTag={onRemoveTag} />
		</div >
	);
};
